const e = 400, t = 1e4;
export {
  e as AnimateTime,
  t as SwiperAutoplayTime
};
//# sourceMappingURL=layout.js.map
